import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sessione-roma',
  templateUrl: './sessione-roma.component.html',
  styleUrls: ['./sessione-roma.component.css']
})
export class SessioneRomaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
